// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4080aea345cf1f9942cc","655":"6ea5dfde01760b70a6c5"}[chunkId] + ".js";
};